import { jsx as _jsx } from "react/jsx-runtime";
// import 'vite/modulepreload-polyfill';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './index.scss';
import { getBasePath } from 'pe-core-frontend';
import { routes } from './routes';
TimeAgo.addDefaultLocale(en);
const router = createBrowserRouter(routes, { basename: getBasePath() });
// Suppress known warnings from third-party libraries
/* eslint-disable @typescript-eslint/unbound-method */
const originalError = console.error;
console.error = (...args) => {
    // Convert all arguments to string to handle various console.error formats
    const errorMessage = args.map(arg => String(arg)).join(' ');
    // Suppress findDOMNode warnings from Material-UI v4 (used in recess library)
    if (errorMessage.includes('findDOMNode') && errorMessage.includes('StrictMode')) {
        return;
    }
    // Suppress ref warnings from function components (legacy library issue)
    if (errorMessage.includes('Function components cannot be given refs')) {
        return;
    }
    originalError.call(console, ...args);
};
/* eslint-enable @typescript-eslint/unbound-method */
ReactDOM.createRoot(document.getElementById('root')).render(_jsx(React.StrictMode, { children: _jsx(RouterProvider, { router: router }) }));
